import Translatable from './i18n/Translatable';

/**
 * BaseService used to indicate that Service is singleton.
 */
export class BaseService {
  moduleName: string = '';
  namespacePrefix: string = '';

  constructor() {
    if (!this.moduleName) {
      this.moduleName = this.constructor.name;
    }
  }

  /**
   * @param key
   * @param options
   */
  translate = (key: string, options?: any) => Translatable.translate(key, this.moduleName, this.namespacePrefix, options);

  /**
   *
   * @param field
   */
  translateErrorMessage = (field: any, options?: any) => Translatable.translateErrorMessage(field, this.moduleName, this.namespacePrefix, options);

  /**
   *
   * @param key
   * @param options
   * @param namespace
   */
  translateByNamespace = (key: string, options = {}, namespace: string = 'common') => Translatable.translateByNamespace(key, options, namespace);

  /**
   *
   * @param namespace
   * @param key
   * @param options
   * @param moduleName
   * @param namespacePrefix
   */
  translateByModuleName = (namespace: string, key: string, options = {}, moduleName: string, namespacePrefix: string = '') => Translatable.translateByModuleName(namespace, key, options, this.moduleName, this.namespacePrefix);
}
